import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import Alert from '../../../../../Alert/Alert';
import TempAccountLimit from '../../../../../Prompts/TempAccountLimit/TempAccountLimit';

import {
  TXTCLI_Just_so_you_know,
  TXTWCL_Verify_my_account,
  TXTWCL_YouXre_using_an_unverified_acc_ELL_1
} from './TempAccountMessage.messages.json';
import { alert, unverified } from './TempAccountMessage.scss';

const TempAccountMessage: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const verifyDoc: boolean = useFeature(FeatureFlag.VerifyDoc);

  const openPrompt = (e: React.MouseEvent) => {
    e.preventDefault();
    isEmbedded && verifyDoc ? window.starsweb?.app.execute('docverify') : setShowPrompt(true);
  };

  return (
    <>
      <Alert variant="warning" className={alert}>
        <Translation {...TXTCLI_Just_so_you_know} />
        <div className={unverified}>
          <Translation {...TXTWCL_YouXre_using_an_unverified_acc_ELL_1} />{' '}
        </div>
        <StarsLink onClick={openPrompt}>
          <Translation {...TXTWCL_Verify_my_account} />
        </StarsLink>
      </Alert>
      {showPrompt && <TempAccountLimit onClose={() => setShowPrompt(false)} />}
    </>
  );
};
export default TempAccountMessage;
